module.exports = __webpack_public_path__ + "../resources/img/storebadge_de.235818b9.png";